import { Body, Controller, Post, Req, Res, UseGuards } from '@nestjs/common';
import { AuthenticationsService } from './authentications.service';

import { returnException } from '@boi/backend-utils';
import { AuthenticationReq, CommonResponse, ForgotPasswordReq, ResetPasswordReq } from '@boi/shared-models';
import { ApiBody, ApiTags } from '@nestjs/swagger';
import { Throttle } from '@nestjs/throttler';
import type { Request, Response } from 'express';
import { Public } from './decorators/public';
import { ChangePasswordDto } from './dtos/change-password.dto';
import { LoginUserDto } from './dtos/user-login.dto';
import { LogoutUserDto } from './dtos/user-logout.dto';
import { LocalAuthGuard } from './guards/local-auth.guard';


@ApiTags('Auth')
@Controller('authentications')
export class AuthenticationsController {

  constructor(
    private readonly authenticationsService: AuthenticationsService,
  ) {

  }



  @Post('createAuthentication')
  async createAuthentication(@Body() authDto: AuthenticationReq): Promise<CommonResponse> {
    try {
      return await this.authenticationsService.createAuthentication(authDto)
    } catch (error) {
      return returnException(CommonResponse, error)
    }
  }

  @Post('UpdateAuthentication')
  async UpdateAuthentication(@Body() authDto: AuthenticationReq): Promise<CommonResponse> {
    try {
      return await this.authenticationsService.UpdateAuthentication(authDto)
    } catch (error) {
      return returnException(CommonResponse, error)
    }
  }

  @Throttle({ default: { limit: 3, ttl: 60 } })
  @Public()
  @Post('getSalt')
  async getSalt(@Body() updateDto: LoginUserDto): Promise<CommonResponse> {
    try {
      return await this.authenticationsService.getSalt(updateDto.username);
    } catch (error) {
      return returnException(CommonResponse, error)
    }
  }

  @Throttle({ default: { limit: 3, ttl: 60 } })
  @Public()
  @UseGuards(LocalAuthGuard)
  @Post('login')
  async login(@Req() req: Request, @Res({ passthrough: true }) response: Response): Promise<CommonResponse> {
    try {
      return await this.authenticationsService.login(req, response);
    } catch (error) {
      return returnException(CommonResponse, error)
    }
  }


  @Post('changePassword')
  async changePassword(@Body() updateDto: ChangePasswordDto): Promise<CommonResponse> {
    try {
      return await this.authenticationsService.changePassword(updateDto.username, updateDto.oldPassword, updateDto.newPassword)
    } catch (error) {
      return returnException(CommonResponse, error)
    }
  }

  @Throttle({ default: { limit: 3, ttl: 60 } })
  @Public()
  @Post('forgot-password')
  async forgotPassword(@Body() req: ForgotPasswordReq): Promise<CommonResponse> {
    try {
      return await this.authenticationsService.sendForgotPasswordOtp(req);
    } catch (error) {
      return returnException(CommonResponse, error)
    }
  }


  @Throttle({ default: { limit: 3, ttl: 60 } })
  @Public()
  @Post('resetPassword')
  async resetPassword(@Body() req: ResetPasswordReq): Promise<CommonResponse> {
    try {
      return await this.authenticationsService.resetPassword(req);
    } catch (error) {
      return returnException(CommonResponse, error)
    }
  }

  @Post('checkPassword')
  @ApiBody({})
  async checkPassword(@Body() req: { username: string, password: string }): Promise<CommonResponse> {
    try {
      return await this.authenticationsService.checkPassword(req);
    } catch (error) {
      return returnException(CommonResponse, error);
    }
  }

  @Post('updatePassword')
  @ApiBody({})
  async updatePassword(@Body() req: { username: string, password: string }): Promise<CommonResponse> {
    try {
      return await this.authenticationsService.updatePassword(req);
    } catch (error) {
      return returnException(CommonResponse, error);
    }
  }

  @Post('getAllUsers')
  @ApiBody({})
  async getAllUsers(@Body() req: any): Promise<CommonResponse> {
    try {
      return await this.authenticationsService.getAllUsers(req);
    } catch (error) {
      return returnException(CommonResponse, error);
    }
  }

  @Post('getAllSessionLogs')
  @ApiBody({})
  async getAllSessionLogs(@Body() req: any): Promise<CommonResponse> {
    try {
      return await this.authenticationsService.getAllSessionLogs(req);
    } catch (error) {
      return returnException(CommonResponse, error);
    }
  }


  @Post('checkPhoneNoAlreadyExist')
  @ApiBody({ schema: { type: 'object', properties: { userName: { type: 'string' } } } })
  async checkPhoneNoAlreadyExist(@Body() req: { userName: string }): Promise<CommonResponse> {
    try {
      return await this.authenticationsService.checkPhoneNoAlreadyExist(req);
    } catch (error) {
      return returnException(CommonResponse, error);
    }
  }

  @Post('logOut')
  async logOut(@Body() logoutUserDto: LogoutUserDto, @Res({ passthrough: true }) response: Response, @Req() req: Request): Promise<CommonResponse> {
    try {
      return await this.authenticationsService.logOut(logoutUserDto, response, req);
    } catch (error) {
      return returnException(CommonResponse, error);
    }
  }

  @Public()
  @Post('updateSessionPhoto')
  @ApiBody({ schema: { type: 'object', properties: { sessionId: { type: 'string' }, photo: { type: 'string' } } } })
  async updateSessionPhoto(@Body() req: { sessionId: string, photo: string }): Promise<CommonResponse> {
    try {
      return await this.authenticationsService.updateSessionPhoto(req);
    } catch (error) {
      return returnException(CommonResponse, error);
    }
  }

}
